import React from 'react'

const About = () => (
  <section id="about" className="about">
    <div className="container">
      <h2 className="section-title">
        【Premium Startup Seminarとは?】
      </h2>
      <div className="section-body">
        <div className="row">
          <div className="col s12 m6 offset-m3">
            <p>
              過去<span className="strong">180回以上</span>の開催実績があるマッチング型の無料イベントです。
              <span className="strong">1日で5社</span>の説明会と座談会を実施、また、<span className="strong">年間7000名以上</span>の採用支援をする、就職エージェント専任研修担当者による、面接対策講座も行います。</p>
          </div>
        </div>
      </div>
    </div>
  </section>
)

export default About